import { createSlice, PayloadAction } from "@reduxjs/toolkit";
//import api from "../../../utils/api";
import BASE_URL from "../api";
import { AppDispatch } from "../../store";

import {
  WaitingList,
  WaitingListState,
  CreateWaitingListPayload,
} from "../types/waitingList";

const initialState: WaitingListState = {
  waitingLists: [],
  waitingList: null,

  loading: false,
  error: null,
  success: null,
};

const slice = createSlice({
  name: "waitingList",
  initialState,

  reducers: {
    start(state) {
      state.loading = true;
      state.error = null;
      state.success = null;
    },

    failed(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },

    fetchSuccess(state, action: PayloadAction<WaitingList[]>) {
      state.loading = false;
      state.waitingLists = action.payload;
    },

    singleSuccess(state, action: PayloadAction<WaitingList>) {
      state.loading = false;
      state.waitingList = action.payload;
    },

    createSuccess(state, action: PayloadAction<WaitingList>) {
      state.loading = false;
      state.success = "Joined waiting list successfully.";

      state.waitingLists.unshift(action.payload);
    },

    deleteSuccess(state, action: PayloadAction<string>) {
      state.loading = false;

      state.waitingLists = state.waitingLists.filter(
        (item) => item.id !== action.payload
      );

      state.success = "Record deleted successfully.";
    },

    clearWaitingListMessage(state) {
      state.error = null;
      state.success = null;
    },
  },
});

export const {
  start,
  failed,
  fetchSuccess,
  singleSuccess,
  createSuccess,
  deleteSuccess,
  clearWaitingListMessage,
} = slice.actions;

export default slice.reducer;

export const fetchWaitingLists =
  () => async (dispatch: AppDispatch) => {
    try {
      dispatch(start());

      const res = await fetch(`${BASE_URL}/waiting-list`, {
        headers: {
          Accept: "application/json",
        },
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || "Unable to fetch waiting list.");
      }

      dispatch(fetchSuccess(data.data));
    } catch (err: any) {
      dispatch(
        failed(err.message || "Unable to fetch waiting list.")
      );
    }
  };

export const fetchWaitingList =
  (id: string) => async (dispatch: AppDispatch) => {
    try {
      dispatch(start());

      const res = await fetch(`${BASE_URL}/waiting-list/${id}`, {
        headers: {
          Accept: "application/json",
        },
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || "Unable to fetch record.");
      }

      dispatch(singleSuccess(data.data));
    } catch (err: any) {
      dispatch(
        failed(err.message || "Unable to fetch record.")
      );
    }
  }; 

export const createWaitingList =
  (payload: CreateWaitingListPayload) =>
  async (dispatch: AppDispatch) => {
    try {
      dispatch(start());

      const res = await fetch(`${BASE_URL}/waiting-list`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (!res.ok) {
        const error =
          data.errors
            ? Object.values(data.errors).flat().join(", ")
            : data.message;

        throw new Error(error);
      }

      dispatch(createSuccess(data.data));

      return data;
    } catch (err: any) {
      dispatch(
        failed(err.message || "Unable to join waiting list.")
      );

      throw err;
    }
  };

export const deleteWaitingList =
  (id: string) => async (dispatch: AppDispatch) => {
    try {
      dispatch(start());

      const res = await fetch(`${BASE_URL}/waiting-list/${id}`, {
        method: "DELETE",
        headers: {
          Accept: "application/json",
        },
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || "Unable to delete record.");
      }

      dispatch(deleteSuccess(id));
    } catch (err: any) {
      dispatch(
        failed(err.message || "Unable to delete record.")
      );
    }
  };

  export type { WaitingListState };